import { ValidatorFn } from '@angular/forms';

export const maxLengthValidator: (params: {
  maxLength: number;
  fieldName: string;
}) => ValidatorFn = ({ fieldName, maxLength }) => {
  return (control) => {
    const value = control.value;
    if (typeof value !== 'string') {
      return { invalidType: '文字列入力を行ってください。' };
    }
    if (value.length > maxLength) {
      return {
        tooLong: `${fieldName}は${maxLength}文字以内で入力してください。`,
      };
    }
    return null;
  };
};
